import React, { FC, useMemo } from 'react';
import { List } from 'immutable';
import { makeStyles } from 'tss-react/mui';
import { useSelector, shallowEqual } from 'react-redux';

import { transactionsTypes } from 'companion-app-components/flux/transactions';
import type RootState from 'companion-app-components/utils/redux-store/rootState';
import { featureFlagsSelectors } from 'companion-app-components/flux/feature-flags';

import { txnHasTags } from 'data/transactions/utils';

import QTip from 'components/QuickenControls/QTip';
import QTypography from 'components/MUIWrappers/QTypography';
import PayeeField from 'components/QuickenControls/PayeeField';

import { styles } from './styles';

interface RegPayeeFieldProps {
  txn: transactionsTypes.CashFlowTransaction,
  onFocus: () => void;
  onChange: () => void;
  onBlur: () => void;
  autoFocus: boolean;
  editable: boolean;
  forceStatic: boolean;
  inputRef: ((input) => void) | null;
  accountIds: List<string>;
}

const useStyles = makeStyles()(styles as Record<string, any>);

const RegPayeeField: FC<RegPayeeFieldProps> = ({ 
  txn, 
  onChange, 
  onFocus, 
  onBlur, 
  editable, 
  forceStatic, 
  autoFocus, 
  inputRef, 
  accountIds,
}) => {

  const { classes, theme } = useStyles();

  const payeeShowFillInfoInMenu = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlags(state).get('payeeShowFillInfoInMenu'), shallowEqual);
  const payeeAutoFillCat = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillCat'), shallowEqual);
  const payeeAutoFillAmount = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillAmount'), shallowEqual);
  const payeeAutoFillMemo = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillMemo'), shallowEqual);
  const payeeAutoFillTags = useSelector((state: RootState) => featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillTags'), shallowEqual);

  const payeeObj = useMemo(() => ({ payee: txn.payee || '' }), [txn.payee]);

  let menuFields = 'payee';
  if (payeeShowFillInfoInMenu) {
    if (payeeAutoFillCat) {
      menuFields += 'category';
    }
    if (Number(txn.amount) === 0 && payeeAutoFillAmount) {
      menuFields += 'amount';
    }
    if (!txn.memo && payeeAutoFillMemo) {
      menuFields += 'memo';
    }
    if (!txnHasTags(txn) && payeeAutoFillTags) {
      menuFields += 'tags';
    }
  }

  return editable ? (
    <PayeeField
      // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
      disableUnderline={theme.mixins?.register.noUnderline}
      accountIds={accountIds}
      menuShowFields={menuFields}
      editable
      // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
      fontSize={theme.mixins?.register.fontSize.default}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      autoFocus={autoFocus}
      value={payeeObj}
      inputRef={inputRef}
      textFieldVariant="standard"
      width="100%"
    />
  ) : (
    // @ts-expect-error: missing props
    <QTip
      wrapOnly
      title={txn.payee}
      wrapId={`${txn.id}-payee`}
    >
      <QTypography
        clickable={!forceStatic ? 'true' : null}
        thinFont
        className={classes.regItemCore}
      >
        {txn.payee}
      </QTypography>
    </QTip>
  );
};

export default (RegPayeeField);
